class SkinBiologyTabs extends HTMLElement {
  #buttons = [];
  #panels = [];
  #media = [];
  #activeIndex = 0;

  #onClick = (e) => {
    const btn = e.target.closest("[data-skin-bio-tab]");
    if (!btn || !this.contains(btn)) return;

    const i = Number(btn.dataset.skinBioIndex);
    if (Number.isNaN(i)) return;

    this.#activate(i, false);
  };

  #onKeydown = (e) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft" && e.key !== "Home" && e.key !== "End") {
      return;
    }

    const btn = e.target.closest("[data-skin-bio-tab]");
    if (!btn || !this.contains(btn)) return;

    e.preventDefault();

    const len = this.#buttons.length;
    let next = this.#activeIndex;

    if (e.key === "ArrowRight") next = (this.#activeIndex + 1) % len;

    if (e.key === "ArrowLeft") next = (this.#activeIndex - 1 + len) % len;

    if (e.key === "Home") next = 0;

    if (e.key === "End") next = len - 1;

    this.#activate(next, true);
  };

  connectedCallback() {
    this.#cache();
    this.#bind();
    this.#activate(this.#activeIndex, false);
  }

  disconnectedCallback() {
    this.#unbind();
  }

  #cache() {
    this.#buttons = [...this.querySelectorAll("[data-skin-bio-tab]")];
    this.#panels = [...this.querySelectorAll("[data-skin-bio-panel]")];
    this.#media = [...this.querySelectorAll("[data-skin-bio-media]")];

    const initial = this.#buttons.findIndex((b) => b.getAttribute("aria-selected") === "true");
    if (initial !== -1) this.#activeIndex = initial;
  }

  #bind() {
    for (const btn of this.#buttons) {
      btn.addEventListener("click", this.#onClick);
      btn.addEventListener("keydown", this.#onKeydown);
    }
  }

  #unbind() {
    for (const btn of this.#buttons) {
      btn.removeEventListener("click", this.#onClick);
      btn.removeEventListener("keydown", this.#onKeydown);
    }
  }

  #activate(index, moveFocus) {
    const len = this.#buttons.length;
    if (len === 0 || index < 0 || index >= len) return;

    this.#activeIndex = index;

    for (let i = 0; i < len; i++) {
      const on = i === index;
      this.#buttons[i].setAttribute("aria-selected", on ? "true" : "false");
      this.#buttons[i].classList.toggle("is-active", on);
      this.#buttons[i].tabIndex = on ? 0 : -1;

      if (this.#panels[i]) this.#panels[i].hidden = !on;

      if (this.#media[i]) this.#media[i].hidden = !on;
    }

    if (moveFocus) this.#buttons[index].focus();
  }
}

if (!customElements.get("skin-biology-tabs")) {
  customElements.define("skin-biology-tabs", SkinBiologyTabs);
}
